import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { prepareHeaders, API, buildError } from '../../api/apis';
import {
  ApiResponse,
  UpdateSupportRequest,
  UpdateSupportResponse,
  GetSupportRequest,
  GetSupportResponse
} from '../../interfaces/interfaces';

export const supportService = createApi({
  reducerPath: 'supportApi',
  tagTypes: ['Support'],
  baseQuery: fetchBaseQuery({
    prepareHeaders: prepareHeaders,
  }),
  endpoints: (builder) => ({
    getSupportDetails: builder.query({
      query: (payload: GetSupportRequest) => ({
        url: `${API.FETCH_SUPPORT(payload)}`,
        method: 'GET',
        }),
      providesTags: () =>  [{ type: 'Support', id: 'GET' }],
      transformResponse: (response: ApiResponse) => {
        return response.Response as GetSupportResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
    updateSupport: builder.mutation({
      query: ({ payload }: { payload: UpdateSupportRequest }) => ({
        url: `${API.UPDATE_SUPPORT(payload)}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: (result, error, { payload }) => [
        { type: 'Support', id: 'GET' },
      ],
      transformResponse: (response: ApiResponse) => {
        return response.Response as UpdateSupportResponse;
      },
      transformErrorResponse: (response) => {
        return buildError(response, "");
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
useGetSupportDetailsQuery, useLazyGetSupportDetailsQuery, useUpdateSupportMutation
} = supportService;
